import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguages } from "../../../redux/slices/superAdmin/languagesSlice";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  StyledButton,
  StyledContainer,
  StyledTableCell,
} from "../../CSS/Styles";

export default function Languages() {
  const dispatch = useDispatch();
  const { languagesList, loading, error } = useSelector(
    (state) => state.languages
  );

  const { companyId } = useSelector((state) => state.app);

  const [newLanguage, setNewLanguage] = useState({
    languageName: "",
  });
  const [editingLanguage, setEditingLanguage] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);

  useEffect(() => {
    if (!languagesList?.length) {
      dispatch(fetchLanguages({ companyId }));
    }
  }, [dispatch, languagesList?.length, companyId]);

  const handleAddLanguage = () => {
    setEditingLanguage(null);
    setNewLanguage({ languageName: "" });
    setIsFormVisible(true);
  };

  const handleEditLanguage = (language) => {
    setEditingLanguage(language);
    setNewLanguage({ ...language });
    setIsFormVisible(true);
  };

  const handleSaveLanguage = () => {
    // Logic to save or update language (dummy implementation for now)
    setNewLanguage({ languageName: "" });
    setEditingLanguage(null);
    setIsFormVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewLanguage((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <StyledContainer>
      <Paper elevation={3} sx={{ padding: 3 }}>
        {!isFormVisible && (
          <Box display="flex" alignItems="center" mb={2}>
            <StyledButton
              sx={{ marginBottom: 2, fontSize: "12px", padding: "8px 16px" }}
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleAddLanguage}
            >
              Add Language
            </StyledButton>
          </Box>
        )}

        {!isFormVisible && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Languages</StyledTableCell>
                  <StyledTableCell>Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {languagesList?.map((language) => (
                  <TableRow key={language.id}>
                    <TableCell>{language.name}</TableCell>
                    <TableCell align="left">
                      <IconButton
                        variant="outlined"
                        onClick={() => handleEditLanguage(language)}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {isFormVisible && (
          <Box mt={3} display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton
                onClick={() => {
                  setNewLanguage({ languageName: "" });
                  setIsFormVisible(false);
                }}
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">
                {editingLanguage ? "Edit Language" : "Add Language"}
              </Typography>
            </Box>
            <TextField
              label="Language Name"
              name="languageName"
              value={newLanguage.languageName}
              onChange={handleInputChange}
              fullWidth
            />
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={() => {
                  setNewLanguage({ languageName: "" });
                  setIsFormVisible(false);
                }}
                sx={{ marginRight: 2 }}
                color="error"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveLanguage}
                color="primary"
                variant="contained"
              >
                Save
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </StyledContainer>
  );
}
